<script lang="ts" setup>
  import { type PropType, onMounted } from 'vue';
  import type { Dictionary, CountriesDictionary } from '@othercommerce/domain';
  import { useFormContext, setModelWithContext } from '@othercommerce/foundation';

  defineProps({
    data: { type: Object as PropType<any>, required: true },
    registerAgencies: { type: Object as PropType<Dictionary>, required: true },
    medicalPracticeGroups: { type: Object as PropType<Dictionary>, required: true },
    medicalTypes: { type: Array as PropType<Dictionary>, required: true },
    countries: { type: Object as PropType<CountriesDictionary>, required: true },
  });

  const context = useFormContext();

  // Force to show PL as country for medical
  onMounted(() => {
    setModelWithContext('countryCode', context, 'PL');
  });
</script>

<template>
  <SfFormTabs :options="medicalTypes" name="rpwdlMedicalType" required />

  <SfFormSelect :label="$t('SHOP.COMMON.LABEL.COUNTRY')" :options="countries" name="countryCode" readonly required />

  <SfFormInput :label="$t('SHOP.COMMON.LABEL.FIRSTNAME')" name="firstName" required />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.LASTNAME')" name="lastName" required />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.EMAIL')" autocomplete="username" name="email" required />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.PHONE')" name="phone" />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.VAT_ID')" name="vatId" required type="text" />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.MEDICAL_CONTRACTOR_REG_NR')" name="rpwdlNumber" required type="text" />
  <SfFormSelect :label="$t('SHOP.COMMON.LABEL.MEDICAL_CONTRACTOR_REG_AGENCY')" :options="registerAgencies" name="rpwdlRegisterAgency" required />

  <SfFormSelect
    v-if="data.rpwdlMedicalType !== 'medicalProvider'"
    :label="$t('SHOP.COMMON.LABEL.MEDICAL_CONTRACTOR_REG_GROUP')"
    :options="medicalPracticeGroups"
    name="rpwdlMedicalPracticeGroup"
    required
  />

  <SfFormInput :label="$t('SHOP.COMMON.LABEL.PASSWORD')" autocomplete="new-password" name="password" required type="password" />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.CONFIRM_PASSWORD')" autocomplete="new-password" name="password_confirmation" required type="password" />
</template>
